import React from "react";

/*
  Spaltenkopf für Tages-Raster (Schichtplan, Verfügbarkeit, Bedarf).

  Zwei Zeilen: oben der Wochentag klein und sekundär, darunter das Datum gross
  und fett. In der Wochenansicht steht der Wochentag ausgeschrieben und darunter
  das Datum ("03.08."), in der Monatsansicht das Kürzel und darunter nur die
  Tageszahl.
*/

export const DAY_HEADER_VIEWS = ["week", "month"];

export default function AppDayHeader({
  weekday,
  day,
  view = "week",
  weekend = false,
  today = false,
  holiday = false,
  marker = null,
  onClick,
  className = "",
  ...props
}) {
  const classes = [
    "ds-day-header",
    `ds-day-header--${view}`,
    weekend ? "is-weekend" : "",
    holiday ? "is-holiday" : "",
    today ? "is-today" : "",
    onClick ? "is-clickable" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const Component = onClick ? "button" : "div";
  const interactiveProps = onClick ? { type: "button", onClick } : { role: "columnheader" };

  return (
    <Component className={classes} {...interactiveProps} {...props}>
      <span className="ds-day-header__weekday">{weekday}</span>
      <span className="ds-day-header__day">{day}</span>
      {marker ? <span className="ds-day-header__marker">{marker}</span> : null}
    </Component>
  );
}
